export enum TypeOperation {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    UPDATE_SERVER = 'UPDATE_SERVER',
    DELETE = 'DELETE',
}